<template lang="html">
  <transition name="move">
    <div class="dialog" ref="dialog">
        <div class="dialog-wrapper">
            <div class="dialog-wrapper-auot"> 

                <span class ="dialogtet">{{ $t('prompt') }}</span>
                
                <span class="dialogtet-tips">{{ $t('completemydirecion') }}</span>
                
                <div class="dialog-okbtn" @click="openAdress($event)">
                    <span class="pay">
                        <!-- 完成 -->
                        OK
                    </span>
                </div>
                 
                <div class="modifyUserdata-err">
                  
                </div> 
                <div class="detail-close" @click="loginHide">
                  <i class="icon-close"></i>
                </div>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
import eventbus from '../../common/js/eventbus.js'

export default {
  props: {
  },
  data() {
    return {
      state: this.$store.state,
      dialogobj: {
        id: this.$store.state.myinfo.username,
        pw: '',
        pw2: '',
        description: this.$store.state.myinfo.description,
        isdialoging: false,
        msg: ''
      }
    }
  },
  updated() {
  },
  methods: {
    loginHide() {
      this.$router.go(-1)
    },
    openAdress() {
      this.$router.push('mymessage')
      eventbus.$emit('open_myaddress', this.state.myinfo)
    }
  },
  created() {
  },
  components: {
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';

.dialog {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
    width: 100%;
    background: rgba(7, 17, 27, 0.5);
    &.move-enter-active,
    &.move-leave-active {
        // 动画过程
        transition: all 0.5s;
        transform: translate3d(0, 0, 0);
    }
    &.move-enter,
    &.move-leave-to {
        // 动画初始态
        transform: translate3d(100%, 0, 0);
    }

    .dialog-wrapper {
        border-radius: 10px;
        position: absolute;
        /* right: auto; */
        bottom: 10%;
        top: 10%;
        left: 10%;
        width: 80%;
        height: 300px;
        margin: auto;
        background-color: #fff;
        .dialog-wrapper-auot {
            width: 80%;
            margin: auto;
            height: 100px;

            .dialogtet {
                display: block;
                font-size: 25px;
                color: #4b2354;
                line-height: 1.2;
                text-align: center;
                padding: 20px 0px;
                @include border-1px(rgba(7, 17, 27, 0.1));
            }

            .dialogtet-tips {
                display: block;
                font-size: 20px;
                color: #4b2354;
                line-height: 1.2;
                text-align: center;
                padding: 50px 0px;
                @include border-1px(rgba(7, 17, 27, 0.1));
            }
            .modifyUserdata {
                position: relative;
                padding: 12px 0;
                box-sizing: border-box;
                @include border-1px(rgba(7, 17, 27, 0.1));
                .modifyUserdata-input {
                    display: flex;
                    padding: 2%;
                    width: 96%;
                    line-height: 24px;
                    background: #f7f7f7;
                    border: 1px solid #ced4da;
                    border-radius: 0.25rem;
                }
                .modifyUserdata-str {
                    display: flex;
                    width: 100%;
                    line-height: 24px;
                    color: #000;
                }
            }

            .modifyUserdata-err {
                width: 100%;
                position: relative;
                top: 25px;
                text-align: center;
                color: red;
            }
            .modifyUserdata-modifyUser {
                width: 100%;
                position: relative;
                top: 15px;
                .checkbtn {
                    height: 16px;
                    width: 16px;
                    color: rgb(0, 180, 60);
                }
                .label-modifyUser {
                    width: 100%;
                    position: relative;
                    left: 5px;
                }
            }
            .dialog-okbtn {
                background: #00b43c;
                border-radius: 10px;
                position: relative;
                width: 100%;
                overflow: hidden;
                height: 40px;
                top: 20px;
                text-align: center;
                .pay {
                    line-height: 40px;
                    text-align: center;
                    font-size: 14px;
                    font-weight: 700;
                    color: #fff;
                    &.not-enough {
                        background: #2b333b;
                    }
                    &.enough {
                        background: #00b43c;
                        color: #fff;
                    }
                }
            }
            .detail-close {
                // background: green;
                width: 32px;
                height: 32px;
                // margin-top: -64px auto 0 auto;
                font-size: 32px;
                line-height: 32px;
                clear: both;
                top: 10px;
                right: 10px;
                position: absolute;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// dialog.vue?3e3a9ee4